"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20MinterBurnerPauserPermit__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "decimals_",
                type: "uint8",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINTER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PAUSER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ERC20MinterBurnerPauserPermit__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_name, _symbol, decimals_, overrides) {
        return super.getDeployTransaction(_name, _symbol, decimals_, overrides || {});
    }
    deploy(_name, _symbol, decimals_, overrides) {
        return super.deploy(_name, _symbol, decimals_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ERC20MinterBurnerPauserPermit__factory = ERC20MinterBurnerPauserPermit__factory;
ERC20MinterBurnerPauserPermit__factory.bytecode = _bytecode;
ERC20MinterBurnerPauserPermit__factory.abi = _abi;
//# sourceMappingURL=ERC20MinterBurnerPauserPermit__factory.js.map